module.exports = __webpack_public_path__ + "static/media/chemours.69e7f0e7.png";